const HIDDEN_OPTION_KEYS = new Set([
    'vendorId',
    'modelId',
    'vendorTableId',
    'vendor',
    'model',
]);

const OPTION_LABEL_OVERRIDES = {
    vendorName: 'Vendor',
    modelName: 'Model',
    vendorType: 'Vendor Type',
    vendortype: 'Vendor Type',
    compressionClass: 'Compression Class',
    lengthType: 'Length Type',
    knitting: 'Knitting',
    size: 'Size',
    lengthsize: 'Length Size',
    shoeSize: 'Shoe Size',
    toeOption: 'Toe Option',
    color: 'Color',
    bandType: 'Band Type',
    bandWidth: 'Band Width',
    footLength: 'Foot Length',
    design: 'Design',
    ankle: 'Ankle',
    fabric: 'Fabric',
    pantyShortCompression: 'Panty/Short Compression',
};

const toDisplayLabel = (key) => {
    const normalizedKey = String(key || '').trim();
    if (!normalizedKey) return '';

    if (OPTION_LABEL_OVERRIDES[normalizedKey]) {
        return OPTION_LABEL_OVERRIDES[normalizedKey];
    }

    return normalizedKey
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
        .trim()
        .replace(/^./, (char) => char.toUpperCase());
};

const isEmptyValue = (value) => {
    if (value === undefined || value === null) return true;
    return String(value).trim() === '';
};

const firstNonEmpty = (...values) => values.find((value) => !isEmptyValue(value));

export const buildOrderOptionSource = ({
    selections = {},
    measurement = {},
    selectedProduct = {},
} = {}) => {
    return {
        ...selections,
        compressionClass: firstNonEmpty(
            selections.compressionClass,
            selections.compressionclass,
            measurement.compressionClass,
            selectedProduct.compressionClass
        ),
        lengthType: firstNonEmpty(
            selections.lengthType,
            selections.lengthtype,
            measurement.lengthType,
            selectedProduct.lengthType
        ),
        knitting: firstNonEmpty(
            selections.knitting,
            selections.knittingType,
            selections.knittingtype,
            measurement.knitting,
            selectedProduct.knitting
        ),
        fabric: firstNonEmpty(
            selections.fabric,
            measurement.fabric,
            selectedProduct.fabric
        ),
    };
};

export const getOrderOptionEntries = (source = {}) => {
    if (!source || typeof source !== 'object') {
        return [];
    }

    return Object.entries(source)
        .filter(([key, value]) => !HIDDEN_OPTION_KEYS.has(key) && !isEmptyValue(value))
        .map(([key, value]) => ({
            key,
            value: String(value),
            label: toDisplayLabel(key),
        }));
};
